import {createSlice} from "@reduxjs/toolkit";


const OrdersHistorySlice = createSlice({
    name: "OrdersHistorySlice",
    initialState: {
        orders: [],
        delivery: "",
        payment: ""
    },
    reducers: {
        setHistory(state, action) {
            state.orders.push(action.payload);
        },
        setMethods(state, action) {
            state.delivery = action.payload.deliveryMethod;
            state.payment = action.payload.paymentMethod;
        }
    }
})


export const {setHistory, setMethods} = OrdersHistorySlice.actions;

export default OrdersHistorySlice.reducer;